<template>
  <div
    class="modal-privacy-tos"
    :style="{ color: fillColor }"
    v-html="parsedPrivacyPolicyText"
  ></div>
</template>

<script setup>
import { useLiquidContextStore } from "@/pinia/liquidContextStore";
import { computed } from "vue";

const liquidContextStore = useLiquidContextStore();
const props = defineProps({ fillColor: String, text: String });

const parsedPrivacyPolicyText = computed(() => liquidContextStore.liquidify(props.text));
</script>
